<div class="lstloging-block">
  <div class="user-detail">
    <span><i class="fa fa-user-circle-o" aria-hidden="true"></i></span>
    <h2><strong>Welcome:</strong> {{userName}} </h2>
  </div>
  <div class="lstlogin" >
    <span><i class="fa fa-hourglass-half"></i></span>
    <h2><strong>Last Printify Data Sync Time:</strong> {{ lastPrintifySync === 0 ? 'N/A' : (lastPrintifySync | date: ' MMMM d, h:mm a') }}</h2>
  </div>
  <div class="lstlogin" >
    <span><i class="fa fa-sign-out" aria-hidden="true"></i></span>
    <h2><strong>Last Login:</strong> {{ lastLogin === 0 ? 'N/A' : (lastLogin | date: 'EEEE, MMMM d, y, h:mm:ss a') }}</h2>
  </div>
</div>